import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const ADDRESS_STEP_SKELETON_CARDS_COUNT = 2
const ADDRESS_STEP_SKELETON_FIELDS_COUNT = 2

export const AddressStepSkeleton = () => (
  <>
    {Array.from({ length: ADDRESS_STEP_SKELETON_CARDS_COUNT }).map(
      (_, cardIndex) => (
        <div
          key={cardIndex}
          className={s.card}
        >
          <Skeleton
            className={s.title}
            borderRadius={6}
          />

          {Array.from({ length: ADDRESS_STEP_SKELETON_FIELDS_COUNT }).map(
            (__, fieldIndex) => (
              <Skeleton
                key={fieldIndex}
                className={s.field}
              />
            ),
          )}
        </div>
      ),
    )}
  </>
)
